export const floatBtn = {
  floatBtnWithdrawl: "Retiro",
  floatBtnDeposit: "Depósito",
};
